import { useGetAllProvincesQuery } from '@report/graphql';
import {
  FormSearchMultipleSelectionWithSelectAllOption,
  type FormSearchMultipleSelectionWithSelectAllOptionProps,
} from '@shared/components';
import { useMemo } from 'react';
import { type FieldValues } from 'react-hook-form';

type ProvinceSearchSelectionProps = Pick<
  FormSearchMultipleSelectionWithSelectAllOptionProps<FieldValues>,
  'name' | 'label' | 'placeholder' | 'sx'
>;

export default function ProvinceSearchSelection(props: Readonly<ProvinceSearchSelectionProps>) {
  const { name, label = 'Province', placeholder, sx } = props;

  const { data: provinceData, loading } = useGetAllProvincesQuery();

  const options = useMemo(() => {
    const provinces = [...(provinceData?.reportGetAllProvinces?.provinces ?? [])];
    return provinces
      .sort((a, b) => a.nameTh.localeCompare(b.nameTh))
      .map((province) => ({
        label: province.nameTh,
        value: province.id,
      }));
  }, [provinceData]);

  return (
    <FormSearchMultipleSelectionWithSelectAllOption
      sx={sx}
      name={name}
      label={label}
      placeholder={placeholder}
      loading={loading}
      slotProps={{
        selectAllOption: {
          label: `Select All (${options.length})`,
        },
      }}
      options={options}
    />
  );
}
